/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ImpactType } from '../models/impact-type';
import { listImpactsForActivityById } from '../fn/impact/list-impacts-for-activity-by-id';
import { ListImpactsForActivityById$Params } from '../fn/impact/list-impacts-for-activity-by-id';
import { listImpactsForProfileById } from '../fn/impact/list-impacts-for-profile-by-id';
import { ListImpactsForProfileById$Params } from '../fn/impact/list-impacts-for-profile-by-id';
import { listImpactsForUserById } from '../fn/impact/list-impacts-for-user-by-id';
import { ListImpactsForUserById$Params } from '../fn/impact/list-impacts-for-user-by-id';
import { listImpactTypes } from '../fn/impact/list-impact-types';
import { ListImpactTypes$Params } from '../fn/impact/list-impact-types';
import { ResponseImpact } from '../models/response-impact';
import { saveImpacts } from '../fn/impact/save-impacts';
import { SaveImpacts$Params } from '../fn/impact/save-impacts';

@Injectable({ providedIn: 'root' })
export class ImpactService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listImpactsForProfileById()` */
  static readonly ListImpactsForProfileByIdPath = '/rest/impact/profile/{id}';

  /**
   * Get list of all impacts for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listImpactsForProfileById()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactsForProfileById$Response(params: ListImpactsForProfileById$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseImpact>>> {
    return listImpactsForProfileById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of all impacts for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listImpactsForProfileById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactsForProfileById(params: ListImpactsForProfileById$Params, context?: HttpContext): Observable<Array<ResponseImpact>> {
    return this.listImpactsForProfileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseImpact>>): Array<ResponseImpact> => r.body)
    );
  }

  /** Path part for operation `listImpactsForActivityById()` */
  static readonly ListImpactsForActivityByIdPath = '/rest/impact/activity/{id}';

  /**
   * Get list of impacts for activity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listImpactsForActivityById()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactsForActivityById$Response(params: ListImpactsForActivityById$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseImpact>>> {
    return listImpactsForActivityById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of impacts for activity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listImpactsForActivityById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactsForActivityById(params: ListImpactsForActivityById$Params, context?: HttpContext): Observable<Array<ResponseImpact>> {
    return this.listImpactsForActivityById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseImpact>>): Array<ResponseImpact> => r.body)
    );
  }

  /** Path part for operation `saveImpacts()` */
  static readonly SaveImpactsPath = '/rest/impact/activity/{id}';

  /**
   * Create new impacts for activity (defined by activity id). All previous impacts are removed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveImpacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveImpacts$Response(params: SaveImpacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseImpact>>> {
    return saveImpacts(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new impacts for activity (defined by activity id). All previous impacts are removed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveImpacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveImpacts(params: SaveImpacts$Params, context?: HttpContext): Observable<Array<ResponseImpact>> {
    return this.saveImpacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseImpact>>): Array<ResponseImpact> => r.body)
    );
  }

  /** Path part for operation `listImpactsForUserById()` */
  static readonly ListImpactsForUserByIdPath = '/rest/impact/user/{id}';

  /**
   * Get list of all impacts for user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listImpactsForUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactsForUserById$Response(params: ListImpactsForUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseImpact>>> {
    return listImpactsForUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of all impacts for user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listImpactsForUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactsForUserById(params: ListImpactsForUserById$Params, context?: HttpContext): Observable<Array<ResponseImpact>> {
    return this.listImpactsForUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseImpact>>): Array<ResponseImpact> => r.body)
    );
  }

  /** Path part for operation `listImpactTypes()` */
  static readonly ListImpactTypesPath = '/rest/impact/listTypes';

  /**
   * Get list of all existing impacts types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listImpactTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactTypes$Response(params?: ListImpactTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImpactType>>> {
    return listImpactTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of all existing impacts types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listImpactTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listImpactTypes(params?: ListImpactTypes$Params, context?: HttpContext): Observable<Array<ImpactType>> {
    return this.listImpactTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ImpactType>>): Array<ImpactType> => r.body)
    );
  }

}
